import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";
import { useAuth } from "../contexts/AuthContext";
import googleIcon from "../assets/icons/google-icon.jpg";
import Head from '../components/Head';

function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState({ message: "", type: "" });

  const { signupWithEmail, signUpWithGoogle } = useAuth();
  const navigate = useNavigate();

  // Email signup
  const handleSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setStatus({ message: "Passwords do not match!", type: "error" });
      return;
    }

    setStatus({ message: "Creating account...", type: "loading" });

    try {
      await signupWithEmail(email, password);
      navigate("/");
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        setStatus({ message: "Email already in use.", type: "error" });
      } else if (error.code === "auth/weak-password") {
        setStatus({
          message: "Password is too weak (must be 6+ characters).",
          type: "error",
        });
      } else {
        setStatus({ message: error.message, type: "error" });
      }
    }
  };

  // Google signup
  const handleGoogleSignUp = async () => {
    setStatus({ message: "", type: "" });
    try {
      await signUpWithGoogle();
      navigate("/");
    } catch (error) {
      console.error("Google Sign Up Error:", error);
      setStatus({ message: error.message, type: "error" });
    }
  };

  return (

      <>
                {/* --- ADDED: SEO METADATA --- */}
                <Head 
                    title="Create Your PDF Play Account – Free Access to All PDF Tools"
                    description="Sign up for PDF Play to unlock free, unlimited access to powerful online PDF tools. Safe, simple, and built for students, professionals, and businesses."
                />
                {/* --- END SEO METADATA --- */}


    <div className="auth-page-container">
      <div className="auth-wrapper">
        <h2>Create your account</h2>

        <form className="auth-form" onSubmit={handleSignup}>
          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.message}
            </div>
          )}

          <div className="auth-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="auth-form-group">
            <label htmlFor="password">Password (6+ characters)</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                ></i>
              </span>
            </div>
          </div>

          <div className="auth-form-group">
            <label htmlFor="confirm-password">Confirm password</label>
            <input
              type="password"
              id="confirm-password"
              className="auth-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="auth-button">
            Create account
          </button>
        </form>

        <div className="auth-separator">
          <br></br>
          <br></br>
          <span>Or sign up with</span>
        </div>

        <div className="social-login-buttons">
          <button onClick={handleGoogleSignUp} className="google-auth-button">
            <img src={googleIcon} alt="Google" className="google-icon" />
            <span>Sign up with Google</span>
          </button>
        </div>

        <div className="auth-switch-link">
          Already have an account? <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default SignupPage;
